const openCalculator = () => {
  window.open(
    'https://app.melver.com.br/hp',
    'hp',
    'resizable=0, height=375, width=600, left=' + (window.innerWidth - 600) / 2 + ', top=' + (window.innerHeight - 375) / 2
  );
};

export default openCalculator;
